MemberOnBoardView = require 'views/member-menu-profile/member-on-board-view'
t = require('views/internal/teacup-with-helpers')()
Util = require 'lib/util'
View = require 'view'

template = t.renderable ({ fullName }) ->
  t.div '.member-full-name-avatar.js-avatar'
  t.div '.member-full-name-name', ->
    t.text fullName

module.exports = class MemberFullNameOnBoardView extends View
  className: 'member-full-name'

  initialize: ({ @board }) ->
    @listenTo @model, 'change:fullName', @render
    return

  events: ->
    'click': (e) ->
      Util.stop(e)
      if !@$(e.target).closest('.js-avatar').length
        @$('.js-avatar .js-member').click()

  render: ->
    @$el.html(template({
      fullName: @model.get('fullName')
    }))

    $avatar = @$('.js-avatar')
    subview = @subview(MemberOnBoardView, @model, { board: @options.board })
    @ensureSubview(subview, $avatar)

    @



// WEBPACK FOOTER //
// ./app/scripts/views/member-menu-profile/member-full-name-on-board-view.coffee